import { combineReducers } from 'redux';

import * as actionTypes from '@store/design/action-types';
import { Types } from '@store/types';

const getAllCollections = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_COLLECTION_REQUEST:
		case actionTypes.FETCH_COLLECTION_FAILURE:
			return state;
		case actionTypes.FETCH_COLLECTION_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllBrands = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_BRAND_REQUEST:
		case actionTypes.FETCH_BRAND_FAILURE:
			return state;
		case actionTypes.FETCH_BRAND_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllMarkets = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_MARKET_REQUEST:
		case actionTypes.FETCH_MARKET_FAILURE:
			return state;
		case actionTypes.FETCH_MARKET_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllCategories = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_CATEGORY_REQUEST:
		case actionTypes.FETCH_CATEGORY_FAILURE:
			return state;
		case actionTypes.FETCH_CATEGORY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllSubCategories = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SUB_CATEGORY_REQUEST:
		case actionTypes.FETCH_SUB_CATEGORY_FAILURE:
			return state;
		case actionTypes.FETCH_SUB_CATEGORY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllSeasons = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SEASONS_REQUEST:
		case actionTypes.FETCH_SEASONS_FAILURE:
			return state;
		case actionTypes.FETCH_SEASONS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllFabricTypes = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FABRIC_TYPE_REQUEST:
		case actionTypes.FETCH_FABRIC_TYPE_FAILURE:
			return state;
		case actionTypes.FETCH_FABRIC_TYPE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllFabrics = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FABRIC_REQUEST:
		case actionTypes.FETCH_FABRIC_FAILURE:
			return state;
		case actionTypes.FETCH_FABRIC_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllColors = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_COLOR_REQUEST:
		case actionTypes.FETCH_COLOR_FAILURE:
			return state;
		case actionTypes.FETCH_COLOR_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllGroupColors = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_COLOR_GROUP_REQUEST:
		case actionTypes.FETCH_COLOR_GROUP_FAILURE:
			return state;
		case actionTypes.FETCH_COLOR_GROUP_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllFabricPatterns = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FABRIC_PATTERN_REQUEST:
		case actionTypes.FETCH_FABRIC_PATTERN_FAILURE:
			return state;
		case actionTypes.FETCH_FABRIC_PATTERN_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllComposition = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FABRIC_COMPOSITION_REQUEST:
		case actionTypes.FETCH_FABRIC_COMPOSITION_FAILURE:
			return state;
		case actionTypes.FETCH_FABRIC_COMPOSITION_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getDesignDetails = (state = {}, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_DESIGN_DETAILS_REQUEST:
		case actionTypes.FETCH_DESIGN_DETAILS_FAILURE:
			return state;
		case actionTypes.FETCH_DESIGN_DETAILS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getDocumentResponse = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_DOC_RESPONSE_REQUEST:
		case actionTypes.FETCH_DOC_RESPONSE_FAILURE:
			return state;
		case actionTypes.FETCH_DOC_RESPONSE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllMatrials = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_MATERIAL_REQUEST:
		case actionTypes.FETCH_MATERIAL_FAILURE:
			return state;
		case actionTypes.FETCH_MATERIAL_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getProductMatrials = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_PRODUCT_MATERIALS_REQUEST:
		case actionTypes.FETCH_PRODUCT_MATERIALS_FAILURE:
			return state;
		case actionTypes.FETCH_PRODUCT_MATERIALS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllTrims = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_TRIMS_REQUEST:
		case actionTypes.FETCH_TRIMS_FAILURE:
			return state;
		case actionTypes.FETCH_TRIMS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getTrimTypes = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_TRIMS_TYPE_REQUEST:
		case actionTypes.FETCH_TRIMS_TYPE_FAILURE:
			return state;
		case actionTypes.FETCH_TRIMS_TYPE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getPomAndSize = (state = {}, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_POM_AND_SIZE_REQUEST:
		case actionTypes.FETCH_POM_AND_SIZE_FAILURE:
			return state;
		case actionTypes.FETCH_POM_AND_SIZE_SUCCESS:
			return { ...state, ...payload };
		case Types.CHANGE_MEASUREMENT_SIZE_CATEGORY_ID:
			return {
				...state,
				sizeCategoryId: payload,
				measurementInfo: { ...state.measurementInfo, sizeCategoryId: payload }
			};
		case actionTypes.CLEAR_POM_AND_SIZE:
			return {};
		default:
			return state;
	}
};

const getProductMeasurement = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_PRODUCT_MEASUREMENT_REQUEST:
		case actionTypes.FETCH_PRODUCT_MEASUREMENT_FAILURE:
			return state;
		case actionTypes.FETCH_PRODUCT_MEASUREMENT_SUCCESS:
			return payload;
		case actionTypes.FETCH_PRODUCT_MEASUREMENT_SUCCESS_DESIGN_TECHPACK:
			return { ...state, techpackMeasurementData: payload };
		default:
			return state;
	}
};

const getAllTemplate = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ALL_TEMPLATE_REQUEST:
		case actionTypes.FETCH_ALL_TEMPLATE_FAILURE:
			return state;
		case actionTypes.FETCH_ALL_TEMPLATE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getBrandingCategories = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_BRANDING_CATEGORY_REQUEST:
		case actionTypes.FETCH_BRANDING_CATEGORY_FAILURE:
			return state;
		case actionTypes.FETCH_BRANDING_CATEGORY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getBrandingTypes = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_BRANDING_TYPE_REQUEST:
		case actionTypes.FETCH_BRANDING_TYPE_FAILURE:
			return state;
		case actionTypes.FETCH_BRANDING_TYPE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getQuantityWiseCosting = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_QUANTITY_WISE_REQUEST:
		case actionTypes.FETCH_QUANTITY_WISE_FAILURE:
			return state;
		case actionTypes.FETCH_QUANTITY_WISE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getInitialCosting = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_INITIAL_COSTING_REQUEST:
		case actionTypes.FETCH_INITIAL_COSTING_FAILURE:
			return state;
		case actionTypes.FETCH_INITIAL_COSTING_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getProductSteps = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_PRODUCT_STEPS_REQUEST:
		case actionTypes.FETCH_PRODUCT_STEPS_FAILURE:
			return state;
		case actionTypes.FETCH_PRODUCT_STEPS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getEnumFilter = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ENUM_FILTER_REQUEST:
		case actionTypes.FETCH_ENUM_FILTER_FAILURE:
			return state;
		case actionTypes.FETCH_ENUM_FILTER_SUCCESS:
			if (payload.type === 'info.nitex.app.materials.EmbellishmentCategory') {
				return {
					...state,
					embellishmentCategory: [state, ...payload.data]
				};
			}
			if (payload.type === 'info.nitex.app.materials.WashProcess') {
				return {
					...state,
					washingCategory: [...payload.data]
				};
			}
			if (payload.type === 'info.nitex.app.materials.UnitType') {
				return {
					...state,
					unitType: [...payload.data]
				};
			}
			if (payload.type === 'info.nitex.app.supplier.CertificateType') {
				return {
					...state,
					certificateType: [...payload.data]
				};
			}
			if (payload.type === 'info.nitex.app.rfq.POSegmentationType') {
				return {
					...state,
					quotationType: [...payload.data]
				};
			}
			break;
		default:
			return state;
	}
};

const getEmbellishmentSubCategory = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_EMBELLISHMENT_SUB_CATEGORY_REQUEST:
		case actionTypes.FETCH_EMBELLISHMENT_SUB_CATEGORY_FAILURE:
			return state;
		case actionTypes.FETCH_EMBELLISHMENT_SUB_CATEGORY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getTrimsSubTypes = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_TRIMS_SUB_CATEGORY_REQUEST:
		case actionTypes.FETCH_TRIMS_SUB_CATEGORY_FAILURE:
			return state;
		case actionTypes.FETCH_TRIMS_SUB_CATEGORY_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getLabelPackSubTypes = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_LABEL_PACK_SUB_TYPE_REQUEST:
		case actionTypes.FETCH_LABEL_PACK_SUB_TYPE_FAILURE:
			return state;
		case actionTypes.FETCH_LABEL_PACK_SUB_TYPE_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getCroppedDesignDetails = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.UPDATE_DESIGN_FAILURE:
			return state;
		case actionTypes.UPDATE_DESIGN_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAvailableSizeForProduct = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SIZE_FOR_PRODUCT_FAILURE:
			return state;
		case actionTypes.FETCH_SIZE_FOR_PRODUCT_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getDesignListToRemoveAfterMove = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.REMOVE_DESIGN_AFTER_MOVE:
			return payload;
		default:
			return state;
	}
};

const getCollectionProducts = (state = null, { type, payload }) => {
	switch (type) {
		case actionTypes.STORE_COLLECTION_PRODUCTS:
			return payload;
		default:
			return state;
	}
};

const designReducer = combineReducers({
	allCollections: getAllCollections,
	allBrands: getAllBrands,
	allMarkets: getAllMarkets,
	allCategories: getAllCategories,
	allSubCategories: getAllSubCategories,
	allSeasons: getAllSeasons,
	allFabricTypes: getAllFabricTypes,
	allFabrics: getAllFabrics,
	allFabricPatterns: getAllFabricPatterns,
	allColors: getAllColors,
	allGroupColors: getAllGroupColors,
	allComposition: getAllComposition,
	designDetails: getDesignDetails,
	documentResponse: getDocumentResponse,
	materials: getAllMatrials,
	productMatrials: getProductMatrials,
	allTrims: getAllTrims,
	trimTypes: getTrimTypes,
	pomAndSize: getPomAndSize,
	productMeasurement: getProductMeasurement,
	allTemplate: getAllTemplate,
	brandingCategories: getBrandingCategories,
	brandingTypes: getBrandingTypes,
	initialCosting: getInitialCosting,
	quantityWiseCosting: getQuantityWiseCosting,
	productSteps: getProductSteps,
	enumFilter: getEnumFilter,
	embellishmentSubCategory: getEmbellishmentSubCategory,
	trimsSubTypes: getTrimsSubTypes,
	labelPackSubTypes: getLabelPackSubTypes,
	croppedDesignDetails: getCroppedDesignDetails,
	sizeForProducts: getAvailableSizeForProduct,
	designListAfterMove: getDesignListToRemoveAfterMove,
	collectionDesignsList: getCollectionProducts
});

export default designReducer;
